/** Shared trial-signup defaults for short email/password forms. */

export const DEFAULT_ORGANIZATION_SIZE = "<50";

export function displayNameFromEmail(email) {
  const local = String(email || "")
    .split("@")[0]
    .trim();
  if (!local) return "User";
  return local.replace(/[._-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
